import { render, staticRenderFns } from "./SetPermission.vue?vue&type=template&id=d0433724&scoped=true"
import script from "./SetPermission.vue?vue&type=script&lang=ts"
export * from "./SetPermission.vue?vue&type=script&lang=ts"
import style0 from "./SetPermission.vue?vue&type=style&index=0&id=d0433724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0433724",
  null
  
)

export default component.exports